export const WEBHOOK_REASONS = {
    image_received: 'image_received',
    image_ai_processed: 'image_ai_processed',
    heartbeat_received: 'heartbeat_received',
    trap_triggered: 'trap_triggered',
    battery_low: 'battery_low',
    catch_detected: 'catch_detected',
    rearmed: 'rearmed',
    offline: 'offline',
    online: 'online',
    configured: 'configured',
    maintained: 'maintained',
    switched_off: 'switched_off',
    catch_reported: 'catch_reported',
    false_triggering: 'false_triggering',
    activity_noticed: 'activity_noticed',
    activity_threshold_reached: 'activity_threshold_reached',
    bait_low: 'bait_low',
    activity_threshold_reached_and_bait_low:
        'activity_threshold_reached_and_bait_low'
}

export const WEBHOOK_TYPES = {
    traplinked: 'traplinked',
    rentokil_tom_images: 'rentokil_tom_images',
    pestsoft: 'pestsoft',
    axinsectai: 'axinsectai'
}

export const REQUEST_METHODS = {
    post: 'post',
    put: 'put',
    patch: 'patch',
    get: 'get',
    delete: 'delete'
}

export const MASK_TOKEN = '********'

export const VERSION_HEADER_KEY = 'traplinked-Version'

// Webhooks created before this header existed are dispatched as v1.0 by webhooks-api
export const LEGACY_VERSION = 'v1.0'

export const WEBHOOKS_DOCS_URL = 'https://docs.traplinked.com/webhooks/'

export const REASON_GROUP_KEYS = {
    device: 'device',
    trap: 'trap',
    image: 'image',
    heartbeat: 'heartbeat',
    activity: 'activity'
}

export const REASONS_BY_GROUP = {
    [REASON_GROUP_KEYS.device]: [
        WEBHOOK_REASONS.online,
        WEBHOOK_REASONS.offline,
        WEBHOOK_REASONS.configured,
        WEBHOOK_REASONS.maintained,
        WEBHOOK_REASONS.battery_low,
        WEBHOOK_REASONS.switched_off
    ],
    [REASON_GROUP_KEYS.trap]: [
        WEBHOOK_REASONS.trap_triggered,
        WEBHOOK_REASONS.catch_detected,
        WEBHOOK_REASONS.catch_reported,
        WEBHOOK_REASONS.rearmed,
        WEBHOOK_REASONS.false_triggering
    ],
    [REASON_GROUP_KEYS.image]: [
        WEBHOOK_REASONS.image_received,
        WEBHOOK_REASONS.image_ai_processed
    ],
    [REASON_GROUP_KEYS.heartbeat]: [WEBHOOK_REASONS.heartbeat_received],
    [REASON_GROUP_KEYS.activity]: [
        WEBHOOK_REASONS.activity_noticed,
        WEBHOOK_REASONS.activity_threshold_reached,
        WEBHOOK_REASONS.bait_low,
        WEBHOOK_REASONS.activity_threshold_reached_and_bait_low
    ]
}

export const REASONS_ORDERED = [
    ...REASONS_BY_GROUP[REASON_GROUP_KEYS.device],
    ...REASONS_BY_GROUP[REASON_GROUP_KEYS.trap],
    ...REASONS_BY_GROUP[REASON_GROUP_KEYS.image],
    ...REASONS_BY_GROUP[REASON_GROUP_KEYS.heartbeat],
    ...REASONS_BY_GROUP[REASON_GROUP_KEYS.activity]
]

const reasonToGroupMap = Object.entries(REASONS_BY_GROUP).reduce(
    (acc, [group, reasons]) => {
        for (const reason of reasons) acc[reason] = group
        return acc
    },
    {}
)

export function reasonToGroup(reason) {
    return reasonToGroupMap[reason] ?? REASON_GROUP_KEYS.device
}
